module.exports = __webpack_public_path__ + "static/img/interior-thumb.847fe1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/interior-thumb.jpg
// module id = PlfO
// module chunks = 0